import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function dateRangeMaxNinetyDaysValidator(dateFromKey: string, dateToKey: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    if (!group.value) return null;

    const dateFromCtrl = group.get(dateFromKey);
    const dateToCtrl = group.get(dateToKey);

    const rawFrom = dateFromCtrl?.value;
    const rawTo = dateToCtrl?.value;

    if (!rawFrom || !rawTo) return null;

    const dateFrom = rawFrom instanceof Date ? rawFrom : new Date(rawFrom);
    const dateTo = rawTo instanceof Date ? rawTo : new Date(rawTo);

    if (isNaN(dateFrom.getTime()) || isNaN(dateTo.getTime())) return null;

    const utcFrom = Date.UTC(dateFrom.getFullYear(), dateFrom.getMonth(), dateFrom.getDate());
    const utcTo = Date.UTC(dateTo.getFullYear(), dateTo.getMonth(), dateTo.getDate());

    const diffDays = Math.round((utcTo - utcFrom) / MS_PER_DAY);

    return diffDays > 90 ? { rangeTooLarge: true } : null;
  };
}
